/* eslint-disable */
import type { RequestContext } from "../RequestContextProto.pb";
import type { ResponseContext } from "../ResponseContextProto.pb";
import type { ScenarioPlan } from "../scenarios.pb";

export interface SelectOptionRequest {
  request_context?: RequestContext;
  /**
   * Pass in the action provided in SelectionOption.
   * Also set ClientScenario on the request header if provided in SelectionOption.
   */
  action?: string;
  /** Payment tokens if call is originating from a flow which has payment context. */
  payment_tokens?: string[];
  /** Transfer token if call is originating from a flow which has transfer context. */
  transfer_token?: string;
}

export interface SelectOptionResponse {
  response_context?: ResponseContext;
  status?: SelectOptionResponseStatus;
  /**
   * Scenario plan with blockers. Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  scenario_plan?: ScenarioPlan;
}

export enum SelectOptionResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  CONCURRENT_MODIFICATION = "CONCURRENT_MODIFICATION",
}
